import React from 'react';
import { Result, Button } from 'antd';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            hasError: false,
        };
    }

    static getDerivedStateFromError(error) {
        return { error, hasError: true };
    }

    componentDidCatch(error, info) {
        if (typeof this.props.onError === 'function') {
            this.props.onError.call(this, error, info.componentStack);
        }
    }

    resetError = () => {
        this.setState({ error: null, hasError: false });
    };

    render() {
        return this.state.hasError ? (
            <div className="gx-page-error-container">
                <Result
                    status="error"
                    title="Oops!"
                    subTitle="Something went wrong, Please try again."
                    extra={[
                        <Button type="primary" key="console" onClick={this.resetError}>
                            Try Again
                        </Button>,
                    ]}
                />
            </div>
        ) : (
                this.props.children
            );
    }
}

export default ErrorBoundary;
